import React from 'react';
import EditangleContainer from 'containers/footer/EditangleContainer';
import CutEditWrapContainer from 'containers/footer/CutEditWrapContainer';
import SectionContainer from 'containers/footer/SectionContainer';
// import ZoomContainer from "containers/footer/ZoomContainer";

/**
 * 푸터 컴포넌트
 */

const Footer = () => {
  return (
    <div className='webeditor_bottom'>
      <EditangleContainer />
      <CutEditWrapContainer />
      <div className='right_position'>
        {/* <ZoomContainer /> */}
        <SectionContainer />
      </div>
    </div>
  );
};

export default Footer;
